import styled from 'styled-components';
import ds from 'designsystem';

const NavButton = styled.a`
  cursor: pointer;
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.headline')};
  line-height: ${ds.get('type.lineHeight.base')};
  margin: ${ds.get('metrics.base')};
  
  font-weight: ${({ active }) => (active ? ds.get('type.fontWeight.bold') : ds.get('type.fontWeight.regular'))};
  
  &:after {
    content: '';
    display: block;
    width: ${({ active }) => (active ? ds.get('metrics.base') : 0)};
    height: 4px;
    margin-top: 4px;
    background-color: ${ds.brand('secondary')};
    transition-duration: 0.25s;
  }
`;

export default NavButton;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HorizontallyNavigableContent/NavButton.jsx